<template>
  <tr>
    <slot v-if="areLp" name="Lp">
      <w-th v-bind="fields['th_Lp']" :width="fields['th_Lp'] ? fields['th_Lp'].width : '5%'" :theadRowspan="theadRowspan">Lp.</w-th>
    </slot>

    <template v-for="(property, propertyIndex) in flatProperties">
      <slot :name="property" :property="properties[property]" :propertyName="property">
        <w-th v-bind="fields[property.startsWith('th_') ? property : 'th_' + property]" :key="propertyIndex" :schema="properties[property]" :theadRowspan="theadRowspan" />
      </slot>
    </template>

    <slot v-if="areRowBtns" name="RowBtns">
      <w-th v-bind="fields['th_RowBtns']" :width="fields['th_RowBtns'] ? fields['th_RowBtns'].width : '5%'" :theadRowspan="theadRowspan">&nbsp;</w-th>
    </slot>
  </tr>
</template>

<script>
import tableMixin from '../mixins/tableMixin';

export default {
  name: 'w-thead',
  mixins: [tableMixin]
};
</script>
